import { Injectable } from '@angular/core';
import { RxAuthService } from '../rx-auth/rx-auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EchelonService {
  constructor(private auth: RxAuthService, private http: HttpClient) {}

  getEchelonVisualizations(echelon: number, rcl: string | number) {
    let url = `${environment.backend_base}main/retailer/get_echelon_content/`;
    let payload = { echelon_id: echelon, rcl_id: rcl };

    return this.http.post(url, payload, this.auth.httpOptions);
  }
}
